package org.hs_soft.runmynesto.domain.model.home.product.tabs.tab_restaurant.delete_addition


import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
data class CashAssist(
    @SerialName("deleteProductAddition")
    val deleteProductAddition: DeleteProductAddition?,
    @SerialName("__typename")
    val typename: String?
)